import React, { useState, useEffect } from 'react';
import './TeacherMessages.css';
import DashboardHeader from '../components/DashboardHeader';
import TeacherNavigationBar from '../components/TeacherNavigationBar';

function TeacherMessages() {
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [messageContent, setMessageContent] = useState('');
  const [recipient, setRecipient] = useState('');
  const [showCompose, setShowCompose] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterType, setFilterType] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const recipients = [
    { id: 'admin', name: 'Administration' },
    { id: 'parents', name: 'Parents' },
    { id: 'eleves', name: 'Élèves' },
    { id: 'collegues', name: 'Collègues enseignants' }
  ];

  useEffect(() => {
    loadMessages();
  }, [filterType]);

  const loadMessages = async () => {
    setLoading(true);
    try {
      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/messages?type=${filterType}`);
      const data = await response.json();

      if (response.ok) {
        const messagesData = Array.isArray(data) ? data : data.data || [];
        setMessages(messagesData);
      }
    } catch (error) {
      console.error('Erreur:', error);
      // Données de test
      setMessages([
        {
          id: 1,
          from: 'Admin',
          subject: 'Réunion pédagogique',
          content: 'Réunion pédagogique demain à 15h en salle 101',
          date: new Date(Date.now() - 2 * 3600000).toISOString(),
          read: false,
          type: 'received'
        },
        {
          id: 2,
          from: 'Parent Dupont',
          subject: 'Question sur les notes',
          content: 'Pourriez-vous m\'expliquer les résultats de mon enfant?',
          date: new Date(Date.now() - 5 * 3600000).toISOString(),
          read: false,
          type: 'received'
        },
        {
          id: 3,
          to: 'Classe 3ème A',
          subject: 'Devoir pour demain',
          content: 'N\'oubliez pas de faire le devoir ex 1-10 page 45',
          date: new Date(Date.now() - 24 * 3600000).toISOString(),
          read: true,
          type: 'sent'
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const sendMessage = async () => {
    if (!recipient || !messageContent.trim()) {
      alert('Veuillez sélectionner un destinataire et écrire votre message');
      return;
    }

    try {
      const response = await fetch('http://127.0.0.1:8000/api/v1/notifications/message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          recipient: recipient,
          subject: 'Message de ' + (localStorage.getItem('teacher_name') || 'Professeur'),
          content: messageContent
        })
      });

      if (response.ok) {
        alert('Message envoyé avec succès');
        setMessageContent('');
        setRecipient('');
        setShowCompose(false);
        loadMessages();
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de l\'envoi du message');
    }
  };

  const handleMessageClick = (message) => {
    setSelectedMessage(message);
    if (!message.read && message.type === 'received') {
      // Marquer comme lu
      const updatedMessages = messages.map(m =>
        m.id === message.id ? { ...m, read: true } : m
      );
      setMessages(updatedMessages);
    }
  };

  const deleteMessage = (messageId) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce message?')) {
      setMessages(messages.filter(m => m.id !== messageId));
      setSelectedMessage(null);
    }
  };

  const filteredMessages = messages.filter(msg => {
    const searchText = (msg.from || msg.to || '').toLowerCase() + (msg.subject || '').toLowerCase();
    return searchText.includes(searchQuery.toLowerCase());
  });

  return (
    <div className="teacher-messages">
      <DashboardHeader />
      <TeacherNavigationBar 
        title="Messages" 
        onBack={() => window.navigateTo && window.navigateTo('teacher-dashboard')}
      />
      <div className="messages-container">
        <main className="messages-main admin-content-full">
          <div className="messages-header" style={{display: 'none'}}>
            <h1>Messages</h1>
            <p>Gérez vos messages et communications</p>
          </div>

          <div className="messages-content">
            <div className="messages-list-panel">
              <div className="messages-toolbar">
                <button
                  className="btn btn-primary btn-small"
                  onClick={() => setShowCompose(!showCompose)}
                >
                  ✎ Nouveau message
                </button>
                <div className="filter-tabs">
                  <button
                    className={`tab ${filterType === 'all' ? 'active' : ''}`}
                    onClick={() => setFilterType('all')}
                  >
                    Tous
                  </button>
                  <button
                    className={`tab ${filterType === 'received' ? 'active' : ''}`}
                    onClick={() => setFilterType('received')}
                  >
                    Reçus
                  </button>
                  <button
                    className={`tab ${filterType === 'sent' ? 'active' : ''}`}
                    onClick={() => setFilterType('sent')}
                  >
                    Envoyés
                  </button>
                </div>
              </div>

              <div className="messages-search">
                <input
                  type="text"
                  placeholder="Rechercher..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              {loading ? (
                <div className="loading">Chargement...</div>
              ) : (
                <div className="messages-list">
                  {filteredMessages.length > 0 ? (
                    filteredMessages.map(message => (
                      <div
                        key={message.id}
                        className={`message-item ${selectedMessage?.id === message.id ? 'active' : ''} ${!message.read ? 'unread' : ''}`}
                        onClick={() => handleMessageClick(message)}
                      >
                        <div className="message-icon">
                          {message.type === 'received' ? '📨' : '📤'}
                        </div>
                        <div className="message-preview">
                          <p className="message-from">{message.from || message.to}</p>
                          <p className="message-subject">{message.subject}</p>
                          <p className="message-date">
                            {new Date(message.date).toLocaleDateString('fr-FR')}
                          </p>
                        </div>
                        {!message.read && <div className="unread-indicator"></div>}
                      </div>
                    ))
                  ) : (
                    <div className="empty-messages">Aucun message</div>
                  )}
                </div>
              )}
            </div>

            <div className="message-detail-panel">
              {showCompose ? (
                <div className="compose-panel">
                  <h2>Nouveau message</h2>
                  <div className="form-group">
                    <label>Destinataire</label>
                    <select
                      value={recipient}
                      onChange={(e) => setRecipient(e.target.value)}
                    >
                      <option value="">Sélectionnez un destinataire</option>
                      {recipients.map(rec => (
                        <option key={rec.id} value={rec.id}>{rec.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Message</label>
                    <textarea
                      value={messageContent}
                      onChange={(e) => setMessageContent(e.target.value)}
                      placeholder="Écrivez votre message..."
                      rows="10"
                    ></textarea>
                  </div>
                  <div className="compose-actions">
                    <button className="btn btn-secondary" onClick={() => setShowCompose(false)}>
                      Annuler
                    </button>
                    <button className="btn btn-primary" onClick={sendMessage}>
                      Envoyer
                    </button>
                  </div>
                </div>
              ) : selectedMessage ? (
                <div className="message-detail">
                  <div className="message-detail-header">
                    <div>
                      <h2>{selectedMessage.subject}</h2>
                      <p className="message-detail-from">
                        {selectedMessage.type === 'received' ? 'De: ' : 'À: '}
                        {selectedMessage.from || selectedMessage.to}
                      </p>
                    </div>
                    <button
                      className="btn-delete"
                      onClick={() => deleteMessage(selectedMessage.id)}
                    >
                      🗑️
                    </button>
                  </div>
                  <div className="message-detail-date">
                    {new Date(selectedMessage.date).toLocaleDateString('fr-FR', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </div>
                  <div className="message-detail-content">
                    {selectedMessage.content}
                  </div>
                </div>
              ) : (
                <div className="empty-detail">
                  <p>Sélectionnez un message pour le lire</p>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default TeacherMessages;
